import { format, getTime, formatDistanceToNow } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  date = date ? format(new Date(date), fm, {
    locale: ptBR,
  }) : '';
  return date
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';
  return date ? format(new Date(date), fm, { locale: ptBR }) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function fLocalFullDateTime(date) {
  const daysOfWeek = [
    'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira',
    'Quinta-feira', 'Sexta-feira', 'Sábado'
  ];

  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Add '0' before single-digit day and minutes
  const formattedDay = day.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `${dayOfWeek}, ${formattedDay} de ${month} de ${year}, ${hours}h${formattedMinutes}`;
}


export function fSecondsToMinutes(seconds) {
  return `${Math.floor(seconds / 60).toString().padStart(1, '0')}:${(Math.round(seconds) % 60).toString().padStart(2, '0')}`;
}


export function fLocalTime(utcDate) {
  if (!utcDate) {
    return '';
  }
  let date = new Date(utcDate);
  const timezoneOffset = date.getTimezoneOffset();
  date = new Date(date.getTime() - timezoneOffset * 60000);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Add '0' before single-digit day and minutes
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `${hours}h${formattedMinutes}`;
}


export function fLocalDate(utcDate) {
  if (!utcDate) {
    return '';
  }
  let date = new Date(utcDate);
  const timezoneOffset = date.getTimezoneOffset();
  date = new Date(date.getTime() - timezoneOffset * 60000);
  const localDay = date.getDate();
  const localMonth = date.getMonth() + 1; // Months are zero-based
  const localYear = date.getFullYear();

  // Format day and month with leading zeros if needed
  const formattedDay = localDay.toString().padStart(2, '0');
  const formattedMonth = localMonth.toString().padStart(2, '0');

  return `${formattedDay}/${formattedMonth}/${localYear}`;
}

export function getCurrentMonthStartDateTime() {
  const date = new Date();
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  return firstDay;
}

export function dateTimeUTCLocalFormat(date, dateFormat) {
  if (!date) return '';
  const smMonths = [
    'Jan', ' Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    ' Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
  ]
  const d = new Date(date);

  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = String(smMonths[d.getUTCMonth()]);
  const year = d.getFullYear();
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');
  const seconds = String(d.getUTCSeconds()).padStart(2, '0');
  const period = d.getUTCHours() < 12 ? 'AM' : 'PM';

  dateFormat = dateFormat.replace('dd', day);
  dateFormat = dateFormat.replace('MMM', month);
  dateFormat = dateFormat.replace('yyyy', year);
  dateFormat = dateFormat.replace('HH', hours);
  dateFormat = dateFormat.replace('mm', minutes);
  dateFormat = dateFormat.replace('ss', seconds);
  dateFormat = dateFormat.replace('a', period);

  return dateFormat;
}

export function dateTimeLocalFormat(date, dateFormat) {
  if (!date) {
    return '';
  }
  let d = new Date(date);
  const timezoneOffset = d.getTimezoneOffset();
  d = new Date(d.getTime() - timezoneOffset * 60000);

  const smMonths = [
    'Jan', ' Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    ' Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
  ]

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(smMonths[d.getMonth()]);
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  const period = d.getHours() < 12 ? 'AM' : 'PM';

  dateFormat = dateFormat.replace('dd', day);
  dateFormat = dateFormat.replace('MMM', month);
  dateFormat = dateFormat.replace('yyyy', year);
  dateFormat = dateFormat.replace('HH', hours);
  dateFormat = dateFormat.replace('mm', minutes);
  dateFormat = dateFormat.replace('ss', seconds);
  dateFormat = dateFormat.replace('a', period);

  return dateFormat;
}

export function fEndOfDay(date) {
  if (!date) {
    return null;
  }
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
}

export function fLocalDateTime(utcDate) {
  if (!utcDate) {
    return '';
  }

  const date = new Date(utcDate);
  const now = new Date();

  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  if (isToday) {
    return `${hours}h${minutes}`;
  }

  const localDay = date.getDate().toString().padStart(2, '0');
  const localMonth = (date.getMonth() + 1).toString().padStart(2, '0');
  const localYear = date.getFullYear();

  return `${localDay}/${localMonth}/${localYear} - ${hours}h${minutes}`;
}

export function fElapsedTime(start, end) {
  const diffMs = new Date(end) - new Date(start);
  const diffSeconds = Math.floor(diffMs / 1000);

  if (diffSeconds < 60) {
    return `${diffSeconds} s`;
  }

  return `${Math.floor(diffSeconds / 60)} min`;
}
